import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Auth
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const exchangeSession = (sessionId) =>
  api
    .post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } })
    .then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);

// Provider
export const getProviderStatus = () =>
  api.get("/settings/provider").then((r) => r.data);

// Websites
export const listWebsites = () => api.get("/websites").then((r) => r.data);
export const createWebsite = (data) =>
  api.post("/websites", data).then((r) => r.data);
export const getWebsite = (id) =>
  api.get(`/websites/${id}`).then((r) => r.data);
export const deleteWebsite = (id) =>
  api.delete(`/websites/${id}`).then((r) => r.data);

// Keywords
export const listKeywords = (websiteId) =>
  api.get(`/websites/${websiteId}/keywords`).then((r) => r.data);
export const addKeywords = (websiteId, keywords) =>
  api
    .post(`/websites/${websiteId}/keywords`, { keywords })
    .then((r) => r.data);
export const deleteKeyword = (id) =>
  api.delete(`/keywords/${id}`).then((r) => r.data);
export const checkKeyword = (id) =>
  api.post(`/keywords/${id}/check`).then((r) => r.data);
export const checkAll = (websiteId) =>
  api.post(`/websites/${websiteId}/check-all`).then((r) => r.data);
export const getCheckJob = (jobId) =>
  api.get(`/check-jobs/${jobId}`).then((r) => r.data);
export const getActiveJob = (websiteId) =>
  api.get(`/websites/${websiteId}/active-job`).then((r) => r.data);
export const keywordHistory = (id) =>
  api.get(`/keywords/${id}/history`).then((r) => r.data);

export const exportCsvUrl = (websiteId) =>
  `${API_BASE}/websites/${websiteId}/export.csv`;
export const publicExportCsvUrl = (token) =>
  `${API_BASE}/public/websites/${token}/export.csv`;
export const reportPdfUrl = (websiteId) =>
  `${API_BASE}/websites/${websiteId}/report.pdf`;
export const publicReportPdfUrl = (token) =>
  `${API_BASE}/public/websites/${token}/report.pdf`;

// Public sharing
export const enableShare = (websiteId) =>
  api.post(`/websites/${websiteId}/share`).then((r) => r.data);
export const disableShare = (websiteId) =>
  api.delete(`/websites/${websiteId}/share`).then((r) => r.data);
export const fetchPublicReport = (token) =>
  api.get(`/public/websites/${token}`).then((r) => r.data);
export const fetchPublicKeywordHistory = (token, keywordId) =>
  api.get(`/public/keywords/${token}/${keywordId}/history`).then((r) => r.data);

// Client logo
export const uploadClientLogo = (websiteId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/websites/${websiteId}/client-logo`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const deleteClientLogo = (websiteId) =>
  api.delete(`/websites/${websiteId}/client-logo`).then((r) => r.data);

// Email report
export const emailReport = (websiteId, payload) =>
  api.post(`/websites/${websiteId}/email-report`, payload).then((r) => r.data);

// AI Visibility
export const listAiKeywords = (websiteId) =>
  api.get(`/websites/${websiteId}/ai-keywords`).then((r) => r.data);
export const addAiKeywords = (websiteId, keywords) =>
  api.post(`/websites/${websiteId}/ai-keywords`, { keywords }).then((r) => r.data);
export const deleteAiKeyword = (id) =>
  api.delete(`/ai-keywords/${id}`).then((r) => r.data);
export const checkAiKeyword = (id) =>
  api.post(`/ai-keywords/${id}/check`).then((r) => r.data);
export const aiCheckAll = (websiteId) =>
  api.post(`/websites/${websiteId}/ai-check-all`).then((r) => r.data);
export const aiVisibility = (websiteId) =>
  api.get(`/websites/${websiteId}/ai-visibility`).then((r) => r.data);
export const listAiModels = () =>
  api.get(`/ai-models`).then((r) => r.data);
